import { render } from "./App.vue?vue&type=template&id=77833f43"
const script = {}

import "./App.vue?vue&type=style&index=0&id=77833f43&lang=scss"

import exportComponent from "/Users/wushaocong/Documents/jishi/亿力售后平台/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__